import {
  BarChart3,
  ClipboardCheck,
  ClipboardPenLine,
  History,
  FileText,
  LogOut,
  Settings2,
  TrendingUp,
  Map,
  UsersRound,
} from "lucide-react";
import { NavLink, Outlet } from "react-router-dom";

import { useAuth } from "@/context/AuthContext";
import { useBrand } from "@/context/BrandContext";

const navigation = [
  { to: "/", label: "Panel", icon: BarChart3, testId: "nav-dashboard" },
  { to: "/cotizador", label: "Cotizador", icon: ClipboardPenLine, testId: "nav-quote" },
  { to: "/cotizaciones", label: "Cotizaciones", icon: History, testId: "nav-quote-history" },
  { to: "/cobranza", label: "Cobranza y Cartera", icon: FileText, testId: "nav-cobranza", roles: ["administrador", "supervisor"] },
  { to: "/clientes", label: "Clientes", icon: UsersRound, testId: "nav-clients" },
  { to: "/reportes", label: "Reportes", icon: TrendingUp, testId: "nav-reports" },
  { to: "/auditoria", label: "Auditoría", icon: ClipboardCheck, testId: "nav-audit", roles: ["administrador", "supervisor"] },
  { to: "/plano", label: "Plano", icon: Map, testId: "nav-plan-preview" },
  { 
  to: "/registro-visitas",
  label: "Registro Visitas",
  icon: UsersRound,
  testId: "nav-plan-visits",
  roles: ["administrador", "supervisor"]
},
  { to: "/administracion", label: "Administración", icon: Settings2, testId: "nav-admin" },
];

export default function Layout() {
  const { logout, user } = useAuth();
  const { brand } = useBrand();

  return (
    <div className="shell" data-testid="application-shell">
      <aside className="sidebar" data-testid="sidebar-navigation">
        <NavLink className="brand" to="/" data-testid="brand-home-link">
          <img
            alt="Puerto Santa Cruz Yacht Club Resort"
            className="brand-logo"
            data-testid="sidebar-brand-logo"
            src={brand.logo_url}
          />
        </NavLink>
        <nav className="nav-list" aria-label="Navegación principal">
          {navigation.filter((item) => !item.roles || item.roles.includes(user.role)).map(({ to, label, icon: Icon, testId }) => (
            <NavLink
              className="nav-item"
              data-testid={testId}
              key={to}
              to={to}
            >
              <Icon size={18} />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-user" data-testid="signed-in-user">
          <span className="user-initial">{user.name.slice(0, 1)}</span>
          <span>
            <strong>{user.name}</strong>
            <small>{user.role}</small>
          </span>
          <button
            aria-label="Cerrar sesión"
            className="icon-button"
            data-testid="logout-button"
            onClick={logout}
            title="Cerrar sesión"
            type="button"
          >
            <LogOut size={17} />
          </button>
        </div>
      </aside>
      <main className="workspace">
        <Outlet />
      </main>
    </div>
  );
}
